
import React from 'react'
import ReactDOM from 'react-dom'
import './index.css'
import './styling/range-slider.css'
import './styling/form-styling.css'
import './styling/summary.css'
import './styling/media-queries.css'


import { App } from './App'



ReactDOM.render(<App />, document.getElementById('root'))
